/* eslint-disable*/
import { useCallback, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

const useHistoryState = (key) => {
	const [state, setState] = useState("");
	let history = useHistory();

	useEffect(() => {
		const { location } = history;
		if (key === null) return;
		if (key === undefined) return;
		if (typeof location.state[key] === typeof undefined) return;

		const type =
			typeof location.state[key] === "object"
				? Array.isArray(location.state[key])
					? "array"
					: "object"
				: typeof history.location.state[key];

		switch (type) {
			case "object":
				setState(Object.assign({}, location.state));
				break;
			case "array":
				setState(Object.assign([], location.state));
				break;
			case "number":
				setState(location.state);
				break;
			case "string":
				setState(location.state);
				break;
			default:
				console.log("Unexpected type");
		}
	}, [history, key]);

	const pushState = useCallback(
		(pathname, key, value) => {
			history.push({
				pathname,
				state: {
					[key]: value
				}
			});
		},
		[history]
	);

	return { state, pushState };
};

export default useHistoryState;
